import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginFromFeedBack } from "../../Store/Login/Action";
import { Button, message } from "antd";
import config from "../../config";
import EndPoints from "../../Constants/EndPoints";
import Constants from "../../Constants/constants";
import Loader from "../../Components/Loader";
import axios from "axios";
import kalyanLogo from '../../Images/KM logo@2x.png'
import * as Images from "../../Components/Kalyanlite/assets/images";
import { useNavigate } from "react-router-dom";
import RouteSegments from "../../Routes/RouteSegment";

const FeedbackResolved = ({ requestNumber = "XXX", onHappy, onNeedHelp }) => {


  const dispatch = useDispatch();
  const [submittedStatus, setSubmittedStatus] = useState({status : null , message : null});

  const { feedbackData, loading } = useSelector((state) => ({
    feedbackData: state.Login?.loginFeedbackData?.data,
    loading: state.Login?.loading,
  }));

  const srNo = localStorage.getItem(Constants.loginLocalStorageKeys.srno);

  
  const navigate = useNavigate()

  useEffect(() => {
    // Dispatch an action to set the current page
    if (feedbackData) return;
    dispatch(loginFromFeedBack(srNo));
  }, [dispatch, feedbackData]);

  const handleFeedbackSubmit = async (confirmStatus) => {
      try {
        const response = await axios.post(
          `${config.api.API_URL}${EndPoints.getFeedbackUrl()}`,
          {
            srno: feedbackData?.srno,
            confirmstatus: confirmStatus,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response?.data?.status === "Success") {
          
          setSubmittedStatus({status : confirmStatus , message : response?.data?.data?.message});
        } else {
          console.error("API Error:", response.statusText);
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };

  return (
    <div className="h-screen bg-[#F8F8F8] flex flex-col items-center justify-center">
      <header
        className="fixed top-0 left-0 w-full z-50 flex items-center justify-between bg-[#FEFEFE] shadow-[0px_4px_6px_rgba(0,0,0,0.1)]"
      >
        <img src={kalyanLogo} className="h-12 md:h-16 object-contain" alt="kalyan logo" />
      </header>  

      <div className="bg-white border border-gray-400 rounded-md shadow-md p-8 !w-[95vw] md:!w-[60vw] lg:!w-[40vw] text-center">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loader />
          </div>
        ) :
        feedbackData?.alreadyshared === "Y" ? (
        <div className="text-start p-4">
          <div className="text-[15px] xl:text-[16px] font-bold text-gray-800 text-center">
            {feedbackData?.message}
          </div>
          <div className="flex items-center justify-center mt-4">
            <button
              className="bg-gray-600 text-white font-semibold px-5 py-2 rounded-md flex items-center justify-center gap-2"
              onClick={() => navigate(RouteSegments.HOME)} // Call API with "N"
            >
              Close
            </button>
          </div>
        </div>
        ) : submittedStatus?.message ? (
          <div className="flex flex-col items-center justify-center gap-2 lg:gap-3 p-4">
            {submittedStatus?.status === "Y" ? (
            <img src={Images.PositiveFeedbackIcon} alt="Feedback Success" className="w-16 h-16 mb-4" />
            ) : (
            <img src={Images.NegativeFeedbackIcon} alt="Feedback Failure" className="w-16 h-16 mb-4" />
            )}
            <div className="text-[15px] xl:text-[16px] font-bold text-gray-800 text-center">
              {submittedStatus?.message}
            </div>

            <div className="flex items-center justify-center mt-4">
              <button
                className="bg-gray-600 text-white font-semibold px-5 py-2 rounded-md flex items-center justify-center gap-2"
                onClick={() => navigate(RouteSegments.HOME)} // Call API with "N"
              >
                Close
              </button>
            </div>
          </div>
          
        ) : (
          <div className="text-start p-4">
            <div className="mb-4 text-[15px] xl:text-[16px] font-bold text-gray-800">
              {feedbackData?.message}
            </div>
            <div className="mb-4 text-[15px] text-gray-700">Kindly share your feedback:</div>
            <div className="flex flex-col gap-3">
              <button
                className="bg-green-600 text-white font-semibold py-2 rounded-md flex items-center justify-center gap-2"
                onClick={() => handleFeedbackSubmit("Y")} // Call API with "Y"
              >
                  Yes, I'm happy
              </button>
              <button
                danger
                className="bg-red-600 text-white font-semibold py-2 rounded-md flex items-center justify-center gap-2"
                onClick={() => handleFeedbackSubmit("N")} // Call API with "N"
              >
                  No, need help
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackResolved;